// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26u5d","content":"styles_content__3wDRd"};